define([
    'react',
    'lodash',
    'form-controls/drop-downs/drop-down/index'
], function (React, _, DropDown) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': this.getClass() }, React.createElement('span', { 'className': 'total' }, 'Total ', this.state.totalCount, ' item(s) found | Show'), React.createElement(DropDown, {
            'className': this.getComboboxClass(),
            'collection': this.collection,
            'value': this.getDefault(),
            'onChange': this.onChange
        }), React.createElement('span', { 'className': 'per-page' }, 'per page'));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-sizer/table-sizer.rt
 ** module id = 198
 ** module chunks = 0
 **/